import { Lookup } from '../../../components/molecules/lookup'
import styled from 'styled-components'

export const FeedstockCombo = styled(Lookup)`
  && {
    width: 100%;
  }
`
